'use strict'

/**
 * @classdesc リスト作成用の役務の選択状況が変わったときの処理を管理
 */
export default class ChangeSelectedCategorizedItems {
	/**
	 * @param {jQuery} $e - $('.selected-categorized-item-count')
	 */
	constructor($e, controller) {
		console.log(`ChangeSelectedCategorizedItems.constructor`)
		this._$e = $e
		this._controller = controller
		this._$itemIdsInput = $(this._$e.data('hidden-input-selector'))
		this._$modal = $(this._$e.data('modal-selector'))
		this._$categoryRoots = this._$modal.find('.category-root')
		this._controller.on('countSelectedCategorizedItems', () => this.count())
		this.initialize()
	}


	initialize() {
		console.log(`ChangeSelectedCategorizedItems.initialize`)
		this.count()

		// モーダル内のカウント対象チェックボックスのイベントをセット
		this._$modal.find('.target-checkbtns-wrapper .input-checkbtn-input').on('change', (e) => {
			const $targetCheckbtn = $(e.currentTarget)
			const $categoryRoot = $targetCheckbtn.closest('.category-root')

			const selectedCountInCategory = $categoryRoot.find('.target-checkbtns-wrapper .input-checkbtn-input:checked').length
			$categoryRoot.find('.selected-item-count-in-category').text(selectedCountInCategory)
			
			const selectedCountInModal = this._$modal.find('.target-checkbtns-wrapper .input-checkbtn-input:checked').length
			this._$e.text(selectedCountInModal)

			this.updateItemIds()
			this._controller.updateToggleAllItemsInCategoryState()
		})
	}


	count() {
		console.log(`ChangeSelectedCategorizedItems.count`)
		this._$categoryRoots.each((_, categoryRootElement) => {
			const $categoryRoot = $(categoryRootElement)

			const allCountInCategory = $categoryRoot.find('.target-checkbtns-wrapper .input-checkbtn-input').length
			const selectedCountInCategory = $categoryRoot.find('.target-checkbtns-wrapper .input-checkbtn-input:checked').length
	
			$categoryRoot.find('.item-count-in-category').text(allCountInCategory)
			$categoryRoot.find('.selected-item-count-in-category').text(selectedCountInCategory)
		})
	
		const selectedCountInModal = this._$modal.find('.target-checkbtns-wrapper .input-checkbtn-input:checked').length
		this._$e.text(selectedCountInModal)
		this.updateItemIds()
	}


	updateItemIds() {
		console.log(`ChangeSelectedCategorizedItems.updateItemIds`)
		const $checkedElements = this._$modal.find('.target-checkbtns-wrapper .input-checkbtn-input:checked')
	
		const itemIds = $checkedElements
			.map((_, element) => $(element).attr('id'))
			.get()
			.join(',')
	
		this._$itemIdsInput.val(itemIds)
	}
}
